export const kbArticles = [
  {
    id: 'KB-1001',
    title: 'Network Drives & Z: Drive Access',
    category: 'Access',
    content: `SOP for "Drive Not Found" or "Access Denied" on Z: and M: shares:
    
    1. PATH VERIFICATION:
       Standard path: \\\\fileserver.internal\\marketing\\z_drive
    2. TROUBLESHOOTING:
       - Verify the user is on the 'Internal' or 'VPN' network. Guest Wi-Fi will not map drives.
       - Run 'net use Z: /delete' followed by 'net use Z: \\\\path /persistent:yes'.
    3. PERMISSIONS:
       Confirm user is in the 'Marketing-Share-ReadWrite' AD Group.`
  },
  {
    id: 'KB-1002',
    title: 'Windows BSOD & Kernel-Power 41',
    category: 'Hardware',
    content: `SOP for continuous crashing after login:
    
    1. DIAGNOSTICS:
       - Boot into Safe Mode with Networking.
       - Check Event Viewer > Windows Logs > System for "Source: Kernel-Power, Event ID: 41".
    2. RESOLUTION:
       - Update the Docking Station firmware (common cause for power-cycle crashes).
       - Run 'sfc /scannow' and 'DISM /Online /Cleanup-Image /RestoreHealth'.
    3. ESCALATION:
       If hardware failure is suspected after firmware updates, initiate a device replacement.`
  },
  {
    id: 'KB-1003',
    title: 'Phishing & Payroll Spoofing',
    category: 'Security',
    content: `SOP for "Verify Payroll Login" and "Gift Card" requests:
    
    1. IMMEDIATE ACTION:
       - Do NOT click links.
       - Forward the email as an attachment to soc@netdesk.pro.
    2. INDICATORS OF COMPROMISE (IoC):
       - Look for 'look-alike' domains (e.g., netdesk-hr.com vs netdesk.pro).
       - Check if the sender's display name matches but the email address is external.
    3. REMEDIATION:
       - Blacklist the sender domain at the mail gateway.
       - Reset the user's password if they interacted with the link.`
  },
  {
    id: 'KB-1004',
    title: 'Conferencing & VIP Zoom Support',
    category: 'VIP / Conferencing',
    content: `SOP for high-priority meeting failures (CEOs/Executives):
    
    1. CONNECTIVITY:
       - Ensure the 'Zoom Desktop Client' is updated to the latest version.
       - Verify 'Hardware Acceleration' is disabled if the screen is flickering.
    2. AUDIO/VIDEO:
       - Check Windows Privacy Settings to ensure 'Allow apps to access your camera' is ON.
       - Verify the correct input device is selected in Zoom settings (e.g., Logi MeetUp vs Integrated).
    3. PRIORITY:
       Provide a dial-in bridge immediately if the app fails to stabilize within 2 minutes.`
  },
  {
    id: 'KB-1005',
    title: 'MFA & Duo Push Issues',
    category: 'MFA',
    content: `SOP for "Prompts not reaching device":
    
    1. DEVICE SYNC:
       - Verify the device has a stable internet connection (Wi-Fi or LTE).
       - Check if the device time is set to 'Automatic'. Manual time offsets break MFA tokens.
    2. APP REFRESH:
       - Instruct user to open the Duo/Authenticator app and 'Pull to refresh'.
    3. REACTIVATION:
       - If the device changed (new phone), send a 'Reactivation Link' via a verified secondary method.`
  },
  {
    id: 'KB-1006',
    title: 'BitLocker & Endpoint Encryption',
    category: 'Endpoint',
    content: `SOP for BitLocker Recovery Key Prompts:
    
    1. CAUSE:
       Usually triggered by BIOS updates, hardware changes, or docking station disconnects during boot.
    2. KEY RETRIEVAL:
       - Access the 'Active Directory Users & Computers' or 'Microsoft Intune' portal.
       - Locate the Device Object > 'BitLocker Recovery' tab.
    3. VERIFICATION:
       Confirm the 'Recovery Key ID' on the user's screen matches the portal before providing the 48-digit key.`
  },
  {
    id: 'KB-1007',
    title: 'Outlook Connectivity & Shared Mailboxes',
    category: 'Email',
    content: `SOP for "Trying to connect" or "Mailbox Missing":
    
    1. CONNECTION:
       - Toggle 'Work Offline' mode on/off to force a reconnection.
       - Check if the '.ost' file size exceeds 50GB (requires compression).
    2. SHARED MAILBOXES:
       - Shared mailboxes should automap via Exchange.
       - If missing: File > Account Settings > More Settings > Advanced > Add.
    3. PERMISSIONS:
       Verify 'Full Access' and 'Send As' permissions are propagated in M365 Admin Center.`
  },
  {
    id: 'KB-1008',
    title: 'DLP & Confidential Data Leaks',
    category: 'Security / DLP',
    content: `SOP for "Confidential attachment sent to wrong recipient":
    
    1. CONTAINMENT:
       - Attempt an 'Outlook Message Recall' immediately (only works for internal recipients).
       - Notify the Security Team to purge the email from the recipient's inbox via PowerShell (Search-Mailbox).
    2. INVESTIGATION:
       - Log the incident in the DLP portal.
       - Identify if the data was PII (Personally Identifiable Information) or PHI.`
  },
  {
    id: 'KB-1009',
    title: 'Telephony & Call Queue Routing',
    category: 'Telephony',
    content: `SOP for "Available but no calls routing":
    
    1. AGENT STATUS:
       - Verify the agent is 'Signed In' to the specific Queue (not just 'Available' in Teams/Cisco).
    2. NETWORK:
       - Check UDP ports 5060/5061 are not being throttled by the local firewall.
    3. CONFIGURATION:
       - Ensure the 'Max Wait Time' for the queue hasn't been set to 0 by mistake in the admin portal.`
  }
];